import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/ResourceSnapshotsInternalResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/snapshots`;
	}
	createFromOrganization(e, t) {
		return this.api.post(this.buildPath(`${n.baseUrl}/self`, t), e);
	}
};
export { n as ResourceSnapshotsInternalResource };

//# sourceMappingURL=ResourceSnapshotsInternalResource.js.map